/* ============================================================
   ROAST'N — small owned enhancements (no vendor files touched)
   ============================================================ */
(function () {
  'use strict';

  /* Clamp long collection descriptions so products aren't pushed
     below the fold; add a Read more / Read less toggle. */
  function clampCollectionDesc() {
    var descs = document.querySelectorAll('.collection-banner__desc');
    for (var i = 0; i < descs.length; i++) {
      var d = descs[i];
      if (d.getAttribute('data-rc')) continue;
      d.setAttribute('data-rc', '1');

      d.classList.add('rc-clamp');
      // Only add a toggle if the text actually overflows the clamp.
      if (d.scrollHeight - d.clientHeight < 6) {
        d.classList.remove('rc-clamp');
        continue;
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rc-toggle';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      (function (desc, button) {
        button.addEventListener('click', function () {
          var open = desc.classList.toggle('rc-open');
          button.textContent = open ? 'Read less' : 'Read more';
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      })(d, btn);

      if (d.parentNode) d.parentNode.insertBefore(btn, d.nextSibling);
    }
  }

  function init() {
    clampCollectionDesc();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
